<template>
  <div class="content">
    <div class="wrap">
      <div class="title">中色云服务</div>
      <div class="info">赋能企业以集成化、数字化、智能化手段解决生产控制、生产管理和企业经营的综合问题，打造服务于企业、赋能于工业的智慧大脑</div>
      <div class="btn">
        <!-- <div class="b" @click="goto">立即购买</div> -->
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "Banner",
    components: {},
    data() {
      return {};
    },
    created() {},
    mounted() {},
    computed: {},
    watch: {},
    methods: {
      goto(){
        window.open('https://platform-cloud.zhongseyun.com/product/select-purchase-info?productType=11&productId=&classValue=')
      },
    },
  };
</script>
<style scoped>
  .content {
    height: 480px;
    background: linear-gradient(180deg, #0e2035 0%, #0f1727 100%);
  }
  .wrap {
    width: 1180px;
    height: 480px;
    margin: 0 auto;
    background: url(@/assets/images/images/ESS-banner-new.png) no-repeat;
    background-position: center center;
    background-size: auto 100%;
  }
  .title {
    height: 56px;
    font-size: 36px;
    font-weight: 400;
    color: #ffffff;
    line-height: 56px;
    box-sizing: content-box;
    padding-top: 130px;
    margin-bottom: 6px;
  }
  .info {
    width: 600px;
    height: 96px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
    margin-bottom: 32px;
  }
  .b{
    width: 200px;
    color: #fff;
    font-weight: normal;
    margin-right: 24px;
    background-color: #005fe1;
    border-radius: 26px;
    text-align: center;
    font-size: 20px;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
  }
</style>
